import React from 'react'



const CustomLoader = () => {
  return (
    <div className="loader-container2">
        <div className="loader"></div>
        <p className=""></p>
    </div>
  )
}

export default CustomLoader